module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2ZXJzaW9uPSIxIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9IiNBRjJEMjciIGQ9Ik0wIDBoMTI4djEyOEgweiIvPjxwYXRoIGZpbGw9IiMyMTQ2OEIiIGQ9Ik0xMjggMHYxMjhIMEwxMjggMHoiLz48dGV4dCBmaWxsPSIjRkZGRkZGIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iNjQiPjx0c3BhbiB4PSIyMyIgeT0iODUiPk5MPC90c3Bhbj48L3RleHQ+PC9nPjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/language-icons/icons/nl.svg
// module id = 6VII
// module chunks = 1